// GAVION ai-email: pending proposed drafts (RLS: a rep reads their own, an admin all). Polled every minute.
import { useGetIdentity, useGetList } from "ra-core";
import { PENDING_FILTER, type AiDraftRow } from "./draftModel";

const POLL_MS = 60_000;

export function usePendingDrafts(o: {
  companyId?: number;
  salesId?: number;
  enabled?: boolean;
}) {
  const filter: Record<string, unknown> = { ...PENDING_FILTER };
  if (o.companyId !== undefined) filter.company_id = o.companyId;
  if (o.salesId !== undefined) filter.sales_id = o.salesId;
  return useGetList<AiDraftRow>(
    "ai_email_drafts",
    {
      filter,
      sort: { field: "created_at", order: "DESC" },
      pagination: { page: 1, perPage: 100 },
    },
    { enabled: o.enabled ?? true, retry: false, refetchInterval: POLL_MS },
  );
}

/** The signed-in user's own pending drafts (nav badge, dashboard card). */
export function usePendingDraftCount(): number {
  const { identity } = useGetIdentity();
  const { total } = useGetList(
    "ai_email_drafts",
    {
      filter: { ...PENDING_FILTER, sales_id: identity?.id },
      sort: { field: "created_at", order: "DESC" },
      pagination: { page: 1, perPage: 1 },
    },
    { enabled: identity?.id != null, retry: false, refetchInterval: POLL_MS },
  );
  return total ?? 0;
}
